import { gql } from 'apollo-angular';

export const INITIATE_REFUND = gql`
  mutation initiateRefund($createRefundInput: CreateRefundInput!) {
    initiateRefund(createRefundInput: $createRefundInput) {
      id
      invoiceId
      customerId
      amount
      currencyId
      refundDate
      paymentMethod
      accountId
      referenceNumber
      notes
      isCheque
      chequeNo
      chequeDate
      refundStatus
      isApproved
      approverId
    }
  }
`;

export const CANCEL_REFUND_BY_ID = gql`
  mutation cancelRefund($refundId: Int!) {
    cancelRefund(refundId: $refundId)
  }
`;

export const APPROVE_OR_REJECT_REFUND = gql`
  mutation approveOrRejectRefund($refundId: Int!, $isApproved: Boolean!) {
    approveOrRejectRefund(isApproved: $isApproved, refundId: $refundId) {
      id
      invoiceId
      amount
    }
  }
`;



export const MODIFY_REFUND = gql`
  mutation modifyRefund($updateRefundInput: UpdateRefundInput!) {
    modifyRefund(updateRefundInput: $updateRefundInput) {
      id
      invoiceId
      customerId
      amount
      currencyId
      refundDate
      paymentMethod
      accountId
      referenceNumber
      notes
      isCheque
      chequeNo
      chequeDate
      refundStatus
      isApproved
      approverId
    }
  }
`;


export const GENERATE_REFUND_PDF = gql`
  mutation generateRefundPdf($refundId: Int!) {
    generateRefundPdf(refundId: $refundId)
  }
`;
